const isUser = require('module/user/helpers/is_user')

module.exports = function isOwner(viewer, page) {
    return (
        page.id === 'profile'
        && isUser(viewer, page.user)
    )
}
